export default __webpack_public_path__ + "static/media/freqRelay.8dd30231.png";